import { Component, OnInit} from '@angular/core';
import { Http} from "@angular/http";
import { ToasterService} from 'angular2-toaster/angular2-toaster';
import {Validators, FormBuilder, FormGroup, FormControl} from "@angular/forms";
import { CustomValidators } from 'ng2-validation';
import {LeadsService} from "../../../models/leads/leads.service";
import {AssignOpenerToLeads} from "../../../models/leads/leads.model";
import {ResponseService} from "../../../models/response/response.service";
import {UsersService} from "../../../models/users/users.service";

@Component({
    selector: 'lead-assign-opener',
    templateUrl: 'lead-assign-opener.template.html',
    styleUrls: ['lead-assign-opener.component.css']
})
export class LeadAssignOpenerComponent implements OnInit{
    public messageText: string = '';
    public errors: Array<any> = [];

    public count: number = 0;
    public openerList: Array<any> = [];
    public fundingSpecialist: Array<any> = [];
    public leadSumList: Array<any> = [];
    public isCheckedAll: boolean = false;
    public openerForm: FormGroup;
    public Leads: LeadsService;

    private model: AssignOpenerToLeads;
    private Users: UsersService;

    // ===========================================================
    // Init
    // ===========================================================

    constructor(private fb: FormBuilder, private http: Http, private toasterService: ToasterService){

        this.Users = new UsersService(this.http);
        this.Leads = new LeadsService(this.http);
    }

    ngOnInit() {
        this.model = LeadsService.getAssignOpenerToLeads();
        this.createForm();
        this.loadOpenerList();
        this.loadUserFSList();
        this.loadLeadsCount();
    }


    // ===========================================================
    // Load Data
    // ===========================================================

    private loadOpenerList() {
        this.Users.getOpener()
            .subscribe(
                (res) => {
                    this.openerList = res.data;
                    this.leadSumList = this.openerList.concat(this.fundingSpecialist);
                },
                (error) => {
                    let errorData = JSON.parse(error._body);
                    console.log(errorData.message);
                });

    }

    private loadUserFSList() {

        this.Users.getFS()
            .subscribe(
                (res) => {
                    this.fundingSpecialist = res.data;
                    this.leadSumList = this.openerList.concat(this.fundingSpecialist);
                },
                (error) => {
                    let errorData = JSON.parse(error._body);
                });
    }

    private loadLeadsCount() {
        let filter = {'limit': 0, 'opener_id': null};

        this.Leads.getList(filter)
            .map(r => r.json())
            .subscribe(
                (res) => {
                    this.count = res.data.count;

                },
                (error) => {
                    let errorData = JSON.parse(error._body);
                    console.log(errorData.message);
                });

    }


    // ===========================================================
    // Actions
    // ===========================================================

    public save( form, isValid: boolean) {

        if (!isValid) {
            return false;
        }
        this.messageText = '';
        this.openerForm.disable();

        form.opener = this.model.opener.map(function(item){
            return +item;
        });

        this.Leads.assignOpener(form)
            .map(r => r.json())
            .subscribe(
                (res) => {
                    this.openerForm.enable();
                    this.openerForm.reset({quantity:0});

                    this.messageText = res.data;
                    this.loadLeadsCount();
                },
                (error) => {
                    this.openerForm.enable();
                    this.openerForm.controls = ResponseService.parseResponseError(this.openerForm.controls, error);
                    this.openerForm.updateValueAndValidity();
                });
    }

    public selectAll() {
        let newOpener = [];
        if(this.isCheckedAll){
            this.leadSumList.map(function(item){
                newOpener.push(item.id.toString());
            });
        }
        this.model.opener = newOpener;
    }

    public changeOpener() {
        if(this.isCheckedAll){
            this.isCheckedAll = false;
        }
    }


    // ===========================================================
    // Functions
    // ===========================================================

    private createForm() {
        // noinspection TypeScriptValidateTypes
        this.openerForm = this.fb.group({
            quantity: new FormControl(this.model.quantity,  [
                Validators.required,
                CustomValidators.number
            ]),
            opener: new FormControl(this.model.opener),
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/views/leads/assign-opener/lead-assign-opener.component.ts